import { useTranslation } from 'react-i18next';

import Collapse from 'components/collapse/Collapse';
import { MESSAGES_SENT_TO_PROPERTY_OWNERS_TEMPLATE_ROWS } from '../SystemTemplatesTab.constants';
import SystemTemplatesTable from './common/SystemTemplatesTable';

const MessagesSentToPropertyOwnersSection = () => {
  const { t } = useTranslation();

  return (
    <Collapse
      data-testid="messages-sent-to-property-owners"
      defaultExpanded
      label={t(
        'pageAutomations.systemTemplates.sections.messagesSentToPropertyOwners',
      )}
      variant="card"
    >
      <SystemTemplatesTable
        data-testid="messages-sent-to-property-owners-table"
        data={MESSAGES_SENT_TO_PROPERTY_OWNERS_TEMPLATE_ROWS}
      />
    </Collapse>
  );
};

export default MessagesSentToPropertyOwnersSection;
